import React from 'react';
import { eventColor } from './ContractRenewalCalendar.helpers';
import {
  detailDateStyle,
  detailEmptyStyle,
  detailHeaderStyle,
  detailItemStyle,
  detailListStyle,
  detailNameStyle,
  detailPanelStyle,
  detailTypeStyle,
  eventSummaryButtonStyle,
  upcomingSectionStyle,
  upcomingTitleStyle,
} from './ContractRenewalCalendarEvents.styles';

function md(date) {
  return String(date || '').slice(5).replace('-', '/');
}

function uniquePeople(events) {
  const seen = new Set();
  const names = [];
  (events || []).forEach((event) => {
    const key = event.row?.user_id || event.row?.name;
    if (!key || seen.has(key)) return;
    seen.add(key);
    names.push(event.row.name);
  });
  return names;
}

function primaryTone(events) {
  return (
    events.find((event) => event.tone === 'red') ||
    events.find((event) => event.tone === 'amber') ||
    events.find((event) => event.tone === 'green') ||
    events[0] ||
    {}
  ).tone;
}

export function primaryEventTone(events) {
  return primaryTone(events);
}

export function EventSummaryButton({ events, onClick }) {
  const names = uniquePeople(events);
  const label = names.length > 1 ? `${names[0]} 외 ${names.length - 1}` : names[0];
  const color = eventColor(primaryTone(events));

  return (
    <button
      type="button"
      style={eventSummaryButtonStyle(color)}
      onClick={onClick}
      title={(events || []).map((event) => `${event.type} ${event.row.name}`).join(', ')}
    >
      {label}
    </button>
  );
}

export function DateEventDetails({ selectedDate, events, onSelectRow }) {
  return (
    <div style={detailPanelStyle}>
      <div style={detailHeaderStyle}>
        <span>{selectedDate ? `${md(selectedDate)} 상세 일정` : '상세 일정'}</span>
        <span>{events.length}건</span>
      </div>
      {selectedDate ? (
        <div style={detailListStyle}>
          {events.length === 0 && <div style={detailEmptyStyle}>이 날짜에는 일정이 없습니다.</div>}
          {events.map((event) => {
            const color = eventColor(event.tone);
            return (
              <button
                type="button"
                key={event.key}
                style={detailItemStyle}
                onClick={() => onSelectRow(event.row)}
              >
                <span style={detailDateStyle}>{md(selectedDate)}</span>
                <span style={detailTypeStyle(color)}>{event.type}</span>
                <span style={detailNameStyle}>{event.row.name}</span>
              </button>
            );
          })}
        </div>
      ) : (
        <div style={detailEmptyStyle}>달력에서 일정이 있는 날짜를 선택하세요.</div>
      )}
    </div>
  );
}

export function UpcomingEventList({ eventsByDate, onSelectDate }) {
  const items = Object.entries(eventsByDate)
    .flatMap(([date, events]) => events.map((event) => ({ date, event })))
    .sort((a, b) => a.date.localeCompare(b.date) || a.event.row.name.localeCompare(b.event.row.name, 'ko-KR'));

  return (
    <div style={upcomingSectionStyle}>
      <div style={upcomingTitleStyle}>다가오는 일정</div>
      <div style={detailListStyle}>
        {items.length === 0 && <div style={detailEmptyStyle}>표시할 일정이 없습니다.</div>}
        {items.map(({ date, event }) => {
          const color = eventColor(event.tone);
          return (
            <button
              type="button"
              key={`${date}-${event.key}`}
              style={detailItemStyle}
              onClick={() => onSelectDate(date)}
            >
              <span style={detailDateStyle}>{md(date)}</span>
              <span style={detailTypeStyle(color)}>{event.type}</span>
              <span style={detailNameStyle}>{event.row.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
